import {useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {rankingLastYear} from "../../constants/ranking";
import {ISearchedRegion} from "../../types/ISearchedRegion";

interface IProps {
    handleGetMoreInfoClick: () => void;
    region: ISearchedRegion;
    className?: string;
}

export function OfferRankingBanner(props: IProps) {
    const {handleGetMoreInfoClick, region} = props;
    const params = useParams<IRankingAnnualParams>();
    const rankingYear = params.year ? params.year : rankingLastYear;

    return (
        <div className={offerRankingBanner}>
            <BrandCrownIcon size="8" wrapperColor="var(--colors-primary)" wrapperSize="8" />

            <div className={content}>
                <Text as="h1" variant="headline_3" fontFamily="secondary" align="center">
                    Ranking inwestycji {region.name_declension_where} {rankingYear}
                </Text>

                <Text variant="body_copy_1" className={bannerText}>
                    Odkryj, które inwestycje {region.name_declension_where} cieszyły się największym zainteresowaniem setek tysięcy naszych użytkowników w{" "}
                    {rankingYear} roku i znajdź swoje wymarzone M.
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
}

const offerRankingBanner = css({
    backgroundColor: "var(--colors-success)",
    borderRadius: 2,
    p: 4,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: 3,
    sm: {
        flexDirection: "row",
        alignItems: "flex-start"
    }
});

const bannerText = css({
    textAlign: "center",
    sm: {
        textAlign: "left"
    }
});

const content = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    alignItems: "center",
    sm: {
        alignItems: "flex-start"
    }
});
import {useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {rankingLastYear} from "../../constants/ranking";
import {ISearchedRegion} from "../../types/ISearchedRegion";

interface IProps {
    handleGetMoreInfoClick: () => void;
    region: ISearchedRegion;
    className?: string;
}

export function OfferRankingBanner(props: IProps) {
    const {handleGetMoreInfoClick, region} = props;
    const params = useParams<IRankingAnnualParams>();
    const rankingYear = params.year ? params.year : rankingLastYear;

    return (
        <div className={offerRankingBanner}>
            <BrandCrownIcon size="8" wrapperColor="var(--colors-primary)" wrapperSize="8" />

            <div className={content}>
                <Text as="h1" variant="headline_3" fontFamily="secondary" align="center">
                    Ranking inwestycji {region.name_declension_where} {rankingYear}
                </Text>

                <Text variant="body_copy_1" className={bannerText}>
                    Odkryj, które inwestycje {region.name_declension_where} cieszyły się największym zainteresowaniem setek tysięcy naszych użytkowników w{" "}
                    {rankingYear} roku i znajdź swoje wymarzone M.
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
}

const offerRankingBanner = css({
    backgroundColor: "var(--colors-success)",
    borderRadius: 2,
    p: 4,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: 3,
    sm: {
        flexDirection: "row",
        alignItems: "flex-start"
    }
});

const bannerText = css({
    textAlign: "center",
    sm: {
        textAlign: "left"
    }
});

const content = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    alignItems: "center",
    sm: {
        alignItems: "flex-start"
    }
});
